import { IonCol, IonContent, IonGrid, IonPage, IonRow } from "@ionic/react";
import { Feedback, Modal } from "app-principal-componentes-visuales";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import Contactanos from "../../components/Modals/Contactanos/Contactanos";
import { COMPONENTE_ASISTENCIA_ERROR, HOME, TITULO_INFORMACION_IMPORTANTE } from "../../utils/constants";
import "./ErrorPage.scss";
import { GA_KEYS, mapGA } from "../../helpers/GTM";
import { AsistenciaMedicaContext } from "../../contexts/AsistenciaMedicaContext";
import { TextoComponente } from "../../interfaces/textoComponente.interface";

interface IErrorPageProps {
	setError: any;
	isWebProp?: boolean
}

const ErrorPage = ({ setError, isWebProp }: IErrorPageProps) => {
	const history = useHistory();
	const [showModal, setShowModal] = useState(false);
	const { setupData, isWeb, asistenciaMedica } = useContext(AsistenciaMedicaContext);
	const textoComponente: TextoComponente = asistenciaMedica?.textoComponentes?.find((textoComponente) => textoComponente.componente === COMPONENTE_ASISTENCIA_ERROR);

	useEffect(() => {
		const configGA = {
			firebase_screen: 'asistenciamedica_error_tecnico'
		}
		mapGA(GA_KEYS.ERROR, setupData, configGA)

	}, [])

	return (
		<div className="asistencia-error_page errorPage">
			<IonGrid className={`${isWeb || isWebProp ? 'asistencia_content-container asistencia-web-mobile-padding' : ''}`}>
				<IonRow>
					<IonCol size='12'>
						<Feedback
							id='problema-tecnico'
							// pathGA='problema-tecnico'
							titulo={isWebProp ? "Tuvimos un problema técnico" : textoComponente?.titulo}
							parrafo={isWebProp ? "Estamos trabajando para resolverlo. Podés contactarnos a través de Whatsapp o llamada telefónica" : textoComponente?.subtitulo}
							handsPhoneError
							labelButtonCancel={isWebProp ? 'Volver a inicio' : textoComponente?.botones?.find(btn => btn.nombre === 'volver-error-tecnico')?.texto}
							onClickCancel={() => {
								setError(false)
								history.replace(HOME);
							}}
							labelButtonOk={isWebProp ? 'Contactanos' : textoComponente?.botones?.find(btn => btn.nombre === 'contactanos-error-tecnico')?.texto}
							onClickOk={() => setShowModal(true)}
						/>
					</IonCol>

				</IonRow>
			</IonGrid>
			<Modal
				className="modal_web"
				hideCloseBtn={false}
				//@ts-ignore
				//TODO VALIDAR QUE MODAL MOSTRAR
				component={<Contactanos screen={'error_page'} menorSeisMeses={false} titulo={TITULO_INFORMACION_IMPORTANTE} />}
				setShowModal={setShowModal}
				showModal={showModal}
				id="error_page-modal"
			/>
		</div>
	)
}

export default ErrorPage;
